<script setup lang="ts">
defineProps<{
  href: string;
  size?: string;
  text?: string;
}>();
</script>

<template>
  <v-btn
    :class="{ [`is-${size}`]: size }"
    class="c-vc-discord-invite-button"
    :href="href"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      class="c-vc-discord-invite-button__img"
      src="/icon_clyde_white_RGB.svg"
    />
    {{ text || (size === "small" ? "再招待" : "VOISCORDをサーバーに招待") }}
  </v-btn>
</template>

<style lang="scss">
.c-vc-discord-invite-button {
  width: fit-content;
  display: flex;
  align-items: center;
  background-color: #6200ee;
  border-radius: 4px;
  border: 0;
  font-weight: 500;
  font-size: 17px !important;
  line-height: 21px !important;
  color: #fff;
  padding: 0 27px;
  outline: none;
  unicode-bidi: plaintext;
  text-decoration: none;
  gap: 8px;

  &.v-btn.v-btn--density-default {
    height: 58px;
  }

  &.is-small {
    padding: 0 18px;
    line-height: 1rem !important;
    font-size: 1rem !important;

    &.v-btn.v-btn--density-default {
      height: 36px;
    }
  }
}

.c-vc-discord-invite-button__img {
  width: 30px;
  margin-right: 8px;

  .is-small & {
    width: 20px;
  }
}
</style>
